import { render, staticRenderFns } from "./PhonesForm.vue?vue&type=template&id=d4082b72&"
import script from "./PhonesForm.vue?vue&type=script&lang=js&"
export * from "./PhonesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports